
    import './styles.scoped.css';
    export default {
  "flash-with-motion": "awsui_flash-with-motion_1q84n_1jsn4_13",
  "enter": "awsui_enter_1q84n_1jsn4_13",
  "flash-body": "awsui_flash-body_1q84n_1jsn4_27",
  "flash-message": "awsui_flash-message_1q84n_1jsn4_27",
  "flash-header": "awsui_flash-header_1q84n_1jsn4_27",
  "flash-content": "awsui_flash-content_1q84n_1jsn4_28",
  "action-button-wrapper": "awsui_action-button-wrapper_1q84n_1jsn4_29",
  "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_1jsn4_30",
  "flash-icon": "awsui_flash-icon_1q84n_1jsn4_53",
  "entering": "awsui_entering_1q84n_1jsn4_66",
  "entered": "awsui_entered_1q84n_1jsn4_87",
  "exiting": "awsui_exiting_1q84n_1jsn4_192",
  "stack": "awsui_stack_1q84n_1jsn4_218",
  "animation-running": "awsui_animation-running_1q84n_1jsn4_218",
  "item": "awsui_item_1q84n_1jsn4_218",
  "flash-list-item": "awsui_flash-list-item_1q84n_1jsn4_219",
  "notification-bar": "awsui_notification-bar_1q84n_1jsn4_220",
  "collapsed": "awsui_collapsed_1q84n_1jsn4_240",
  "animation-ready": "awsui_animation-ready_1q84n_1jsn4_240",
  "expanded-only": "awsui_expanded-only_1q84n_1jsn4_240",
  "expanded": "awsui_expanded_1q84n_1jsn4_240",
  "flash": "awsui_flash_1q84n_1jsn4_13",
  "collapsible": "awsui_collapsible_1q84n_1jsn4_296",
  "short-list": "awsui_short-list_1q84n_1jsn4_302",
  "visual-refresh": "awsui_visual-refresh_1q84n_1jsn4_340",
  "status": "awsui_status_1q84n_1jsn4_413",
  "header": "awsui_header_1q84n_1jsn4_413",
  "item-count": "awsui_item-count_1q84n_1jsn4_414",
  "button": "awsui_button_1q84n_1jsn4_415",
  "type-count": "awsui_type-count_1q84n_1jsn4_448",
  "count-number": "awsui_count-number_1q84n_1jsn4_448",
  "icon": "awsui_icon_1q84n_1jsn4_482",
  "floating": "awsui_floating_1q84n_1jsn4_523",
  "flashbar": "awsui_flashbar_1q84n_1jsn4_527",
  "initial-hidden": "awsui_initial-hidden_1q84n_1jsn4_587",
  "flash-list": "awsui_flash-list_1q84n_1jsn4_219",
  "flash-focus-container": "awsui_flash-focus-container_1q84n_1jsn4_611",
  "flash-text": "awsui_flash-text_1q84n_1jsn4_641",
  "hidden": "awsui_hidden_1q84n_1jsn4_660",
  "header-replacement": "awsui_header-replacement_1q84n_1jsn4_665",
  "content-replacement": "awsui_content-replacement_1q84n_1jsn4_670",
  "dismiss-button": "awsui_dismiss-button_1q84n_1jsn4_30",
  "action-wrapped": "awsui_action-wrapped_1q84n_1jsn4_688",
  "action-button": "awsui_action-button_1q84n_1jsn4_29",
  "action-slot": "awsui_action-slot_1q84n_1jsn4_695",
  "flash-type-success": "awsui_flash-type-success_1q84n_1jsn4_699",
  "flash-type-error": "awsui_flash-type-error_1q84n_1jsn4_707",
  "flash-type-info": "awsui_flash-type-info_1q84n_1jsn4_715",
  "flash-type-in-progress": "awsui_flash-type-in-progress_1q84n_1jsn4_716",
  "flash-type-warning": "awsui_flash-type-warning_1q84n_1jsn4_725"
};
  